import { createGlobalStyle } from 'styled-components';
import InitialsFill1 from '../assets/fonts/EBGaramond-InitialsF1.woff2';
import InitialsFill2 from '../assets/fonts/EBGaramond-InitialsF2.woff2';

const Typography = createGlobalStyle`
@font-face {
  font-family: 'Initials-Fill-1';
  src: url(${InitialsFill1});
}

@font-face {
  font-family: 'Initials-Fill-2';
  src: url(${InitialsFill2});
}

html.light {
    --body-font: 'EB Garamond', Georgia, serif;
    --fancy-font: "Manufacturing Consent", Georgia, serif;
    
    --dropcap-bg-font: 'Initials-Fill-1', Georgia, serif;
    --dropcap-char-font: 'Initials-Fill-2', Georgia, serif;

    --h1-font-size: 3.2rem;
    --logo-font-size: 4rem;
    --quote-font-size: 1.8rem;
    --footer-quote-font-size: 1.2rem;
    --link-grad: linear-gradient(to right, #8b1e0f, #6b140a);
    --link-fallback-color: #8b1e0f;
    --category-text-color: #2c2420;

    html {
      text-shadow: none;
    }

    .drop-cap {
      position: relative;
      display: inline-block;
      font-family: var(--dropcap-bg-font, 'Initials-Fill-1', Georgia, serif);
      color: var(--primary);
      float: left;
      font-size: 5rem;
      font-weight: 300;
      line-height: 0.8;
      padding-right: 0.15em;
      margin-top: 0.2em;

      &::before {
        content: attr(data-letter);
        position: absolute;
        top: 0;
        left: 0;
        font-family: var(--dropcap-char-font, 'Initials-Fill-2', Georgia, serif);
        color: black;
        pointer-events: none;
      }
    }

    .nav li a {
      font-weight: 700;
    }

    .card-title {
      font-weight:900;
      font-size:2rem;
      font-variant-caps:titling-caps;
    }

    .title h2 {
      font-size:2.5rem;
      font-family: var(--body-font);
      font-variant-caps:titling-caps;
    }

    .footer-quote {
      line-height:2.5rem;
      font-size:1.75rem;
    } 

    .body-text p {
      font-weight:600;
    }
}

:root {
    --body-font: 'Blinker', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    --fancy-font: 'VT323',  monospace;
    --h1-font-size: 4.8rem;
    --h2-font-size: 3.4rem;
    --logo-font-size: 3.5rem;
    --quote-font-size: 2.5rem;
    --footer-quote-font-size: 1.8rem;
    --link-grad: var(--primary-grad);
    --link-fallback-color: #FFD063;
    --blog-category-bg: var(--primary-grad);
    --blog-category-border: none;
    --project-category-bg: var(--secondary-grad);
    --project-category-border: none;
    --category-text-color: black;
  }
  
  html {
    /* font-family: Georgia, 'Times New Roman', Times, serif; */
    font-family: var(--body-font);
    color: var(--body);
    /* text-shadow: var(--glow) 0px 0px 6px; */
  }

  p, li {
    line-height: 3rem;
    font-size:18px;
    letter-spacing: 1px;
    font-weight:500;
  }

  h1,h2,h3,h4,h5,h6{
    font-family: var(--body-font);
    font-weight: 700;
    margin: 0;
    margin-bottom:2rem;
    text-align: left;
    color: var(--body);
  }

  .title h2 {
    font-size:2.5rem;
    font-family: var(--fancy-font);
    font-variant-caps:titling-caps;
  }

  .block p, .block blockquote, .block div, .block h2 {
    margin-bottom:4rem;
    margin-top:0;
  }

  .button {
    font-family: var(--body-font);
    font-size: 1.5rem;
  }

  .notice-container {
    font-family: var(--body-font);
    text-align: center;
    font-size: 70%;
    font-weight: 600;
    letter-spacing: 1px;
  }

  h1, h2 {
    font-family: var(--body-font);
  }

  .logo a {
    font-family: var(--fancy-font);
  }

  h1 {
    text-align:center;
    font-size: var(--h1-font-size);
  }

  h2 {
    font-size: var(--h2-font-size);
  }

  .card-title {
    font-family: var(--fancy-font);
    font-size: 2.4rem;
    font-variant-caps:titling-caps;
    letter-spacing: 2px;
  }

  .logo a {
    font-weight: 900;
    margin: 0px;
    background:none;
    background-clip: unset;
    -webkit-background-clip: unset;
    -webkit-text-fill-color: unset;
  }
  .about {
    font-weight: 600;
    font-size: 1.5rem;
    /* font-variant-caps: all-petite-caps; */
  }

  .nav li a {
    font-family: var(--body-font);
    font-weight: 600;
    font-variant-caps: all-small-caps;
    margin: 0;
    background:none;
    background-clip: unset;
    -webkit-background-clip: unset;
    -webkit-text-fill-color: unset;
  }
  li a, p a {
    text-decoration: none;
    color: var(--link-fallback-color, #FFD063);
    background: linear-gradient(transparent 60%, var(--primary)70% 10px);
    background-image: var(--link-grad, var(--primary-grad));
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
  }

  p a :hover {
    text-decoration: underline;
  }
  
  .center {
    text-align: center;
  }
  .sans-serif {
    font-family: var(--body-font);
  }
  .serif {
    font-family: Georgia, 'Times New Roman', Times, serif;
  }

  .card-title {
      font-weight:900;
      font-size:2rem;
      font-variant-caps:all-small-caps;
  }

  blockquote {
    font-family: var(--fancy-font);
    font-size: var(--quote-font-size);
  }
  .footer-quote {
    font-family: var(--fancy-font);
    text-align: center;
    font-size: var(--footer-quote-font-size, 1.3rem);
    font-weight: 300;
  }
`;

export default Typography;
